import { GlobalConstants } from "../../data/GlobalConstants";
import { handleResponse } from "../../util/functions";
import { getToken } from "../../helpers/helperJWT";
import { loaderService } from "../loaderService";

const url = GlobalConstants.urlApi;

const getCategorias = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/categorias/getCategorias`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const getCategoriasNombres = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/categorias/getCategoriasNombres`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const updateEstadoCategoria = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/categorias/updateEstadoCategoria`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const validateAsignacionEliminar = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/categorias/validateAsignacionEliminar`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const deleteCategoria = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/categorias/deleteCategoria`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const updateCategoria = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/categorias/updateCategoria`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const saveCategoria = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/categorias/saveCategoria`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const saveImagen = ({file, idCat, nombreImg, extension}) => {
    const formData = new FormData();

    formData.append('id', idCat.toString());
    formData.append('extension', extension);
    formData.append('nombreImg', nombreImg);
    formData.append('img', file);

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': getToken()
        },
        body: formData
    };

    return fetch(`${url}/unoauno/categorias/saveImagen`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

export const categoriasService = {
    getCategorias,
    getCategoriasNombres,
    updateEstadoCategoria,
    validateAsignacionEliminar,
    deleteCategoria,
    updateCategoria,
    saveCategoria,
    saveImagen
};